<div class="flex flex-col">
  <span class="soft-overline">{{item['plangruppe']}}</span>
  <div class="flex flex-row">
    <span class="font-bold">{{item['bezeichnung']}}</span>
  </div>
  <div class="flex flex-row text-sm text-light">
    <span>{{item['beschreibung']}}</span>
  </div>
</div>
